import { render, staticRenderFns } from "./PageResult.vue?vue&type=template&id=fcb118cc&scoped=true"
import script from "./PageResult.vue?vue&type=script&lang=js"
export * from "./PageResult.vue?vue&type=script&lang=js"
import style0 from "./PageResult.vue?vue&type=style&index=0&id=fcb118cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb118cc",
  null
  
)

export default component.exports